// extracted by mini-css-extract-plugin
module.exports = {"secondaryNavBar":"style__secondaryNavBar__qCNu7","tabButton":"style__tabButton__P8hEL","link":"style__link__fcEiv"};